export type LatLngLiteral = { lat: number; lng: number };

/** Parse booking pickup/drop JSON from API (supports multiple legacy shapes). */
export function parseLatLng(raw: unknown): LatLngLiteral | null {
  if (raw == null) return null;

  let obj: unknown = raw;
  if (typeof raw === 'string') {
    const trimmed = raw.trim();
    if (!trimmed) return null;
    try {
      obj = JSON.parse(trimmed);
    } catch {
      return null;
    }
  }

  if (typeof obj !== 'object' || obj === null) return null;
  const o = obj as Record<string, unknown>;

  let lat = Number(o.lat ?? o.latitude ?? o.Lat);
  let lng = Number(o.lng ?? o.longitude ?? o.Lng ?? o.lon ?? o.long);

  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    const coords = o.coordinates;
    if (Array.isArray(coords) && coords.length >= 2) {
      lng = Number(coords[0]);
      lat = Number(coords[1]);
    }
  }

  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  if (Math.abs(lat) < 0.000001 && Math.abs(lng) < 0.000001) return null;

  return { lat, lng };
}

export function latLngToParam(point: LatLngLiteral): string {
  return `${point.lat},${point.lng}`;
}

/** Decode Google encoded polyline into lat/lng points. */
export function decodePolyline(encoded: string): LatLngLiteral[] {
  if (!encoded) return [];

  let index = 0;
  const len = encoded.length;
  let lat = 0;
  let lng = 0;
  const coordinates: LatLngLiteral[] = [];

  while (index < len) {
    let b = 0;
    let shift = 0;
    let result = 0;
    do {
      b = encoded.charCodeAt(index++) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);
    const dlat = (result & 1) !== 0 ? ~(result >> 1) : result >> 1;
    lat += dlat;

    shift = 0;
    result = 0;
    do {
      b = encoded.charCodeAt(index++) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);
    const dlng = (result & 1) !== 0 ? ~(result >> 1) : result >> 1;
    lng += dlng;

    coordinates.push({ lat: lat / 1e5, lng: lng / 1e5 });
  }

  return coordinates;
}
